// extracted by mini-css-extract-plugin
export var container = "_ag-0";
export var containerTopRight = "_ag-1";